<template>
    <lms-dialog :drawerVisible='isVisible' @visible='v=>isVisible=v' @visibleChang="visibleChang" :title="title" :width="width">
        <div class="dialog-body">
            <el-rate v-model="rate" show-score score-template="{value}"></el-rate>
            <el-input
                type="textarea"
                placeholder="说说学完本课程的收获吧~"
                :autosize="{ minRows: 8, maxRows: 20}"
                v-model="textarea">
            </el-input>
        </div>
    </lms-dialog>
</template>
<script>
import lmsDialog from '@p/components/lessonDialog/lms-dialog.vue'
export default {
    data(){
        return {
            rate:0,
            textarea:'',
        }
    },
    props:{
        drawerVisible:{
            type:Boolean,
            default:false,
        },
        width: {
            type: [String],
        },
        title: {
            type: [String],
        },
    },
    watch:{
        drawerVisible(e){
            if (!e) {
                this.rate=0,
                this.textarea=''
            }
        }
    },
    computed:{
        isVisible:{
            set (v) {
                this.$emit('visible', v)
            },
            get () {
                return this.drawerVisible
            }
        }
    },
    methods:{
        //返回 分数，评价
        visibleChang(){
            this.$emit('visibleChang',this.rate,this.textarea)
        }
    },
    components:{
        lmsDialog
    }
}
</script>
<style lang="less" scoped>
.dialog-body{
    padding: 26px 32px;
}
.el-textarea{
    margin-top: 26px;
}
</style>
